<template>
  <footer :class="classList">
    <slot>NZS Admin&nbsp;<router-link :to="{ name: 'ChangeLogList' }" class="card-link">v{{ $store.getters.appVersion }}</router-link>&nbsp;(&copy; {{ new Date().getFullYear() }} N Zone Sports of America)</slot>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  props: {
    fixed: {
      type: Boolean,
      default: false
    }
  },
  mounted: function () {
    this.isFixed()
  },
  computed: {
    classList () {
      return [
        'app-footer'
      ]
    }
  },
  methods: {
    isFixed () {
      this.fixed ? document.body.classList.add('footer-fixed') : document.body.classList.remove('footer-fixed')
    }
  }
}
</script>
